import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import useBaseInfo from "../../store/useBaseInfo";
import useBasicFormData from "../../store/useBasicFormData";
import useVehicleList from "../../store/useVehicleList";
import useGetCh from "../../../../hooks/useGetCh";
import useCurrentVeichle from "../../../../hooks/useVehicle";
import { sendReport } from "../../../../utils/reporter";
import styles from "./index.module.scss";
import {
  TAB_ID_SET
} from "../../config/constants";

// const DOMAIN_MAP = {
//   dev: 'http://das.test.xiaopeng.local',
//   test: 'http://das.test.xiaopeng.local',
//   pre: 'https://das.deploy-test.xiaopeng.com',
//   production: 'https://das.xiaopeng.com',
// }

export default function VehicleCard() {
  const history = useHistory();
  const ch = useGetCh();
  const {
    baseInfo,
    setContentEdited,
    setSelectedVehicle,
    setModifyReserveId
  } = useBaseInfo();
  const {
    setStoreTimeTabIndex,
    setContactInfoData,
    setDatesContentOfStoreTab,
    setStoreContentOfStoreTab,
    setDatesStoreContentOfDateTab,
    setModifyOrderArriveStoreTime,
    setModifyOrderShopCode
  } = useBasicFormData();
  const { vehicleList } = useVehicleList();
  const [showCarList, setShowCarList] = useState(false);
  const preBodyPositionState = useRef("");
  const { handleCurrentVeichle } = useCurrentVeichle();

  useEffect(() => {
    if (showCarList) {
      preBodyPositionState.current = document.body.style.position;
      document.body.style.position = "fixed";
      document.body.style.width = "100vw";
    } else {
      document.body.style.position = preBodyPositionState.current || "static";
      document.body.style.width = "auto";
    }
  }, [showCarList]);

  const onTapSwitchCar = () => {
    setShowCarList((preState) => !preState);
  };

  const resetVinRelativeData = () => {
    setContactInfoData({
      loadedServiceRight: false,
      usePickupService: true, // 重置为默认选中
      hasPickupServiceRight: false,
      pickupRightUrl: ""
    });
    // 重置日期及门店选择（请求跟 vin 有关）
    setStoreTimeTabIndex(TAB_ID_SET.DATE_TAB);
    setDatesContentOfStoreTab(null);
    setStoreContentOfStoreTab(null);
    setDatesStoreContentOfDateTab(null);
    setContentEdited(true);
    setModifyOrderArriveStoreTime(0);
    setModifyOrderShopCode("");
    setModifyReserveId('');
  };

  // 点击切换车型
  const onTapCarItemHandler = (item) => {
    if (!baseInfo.selectedVehicle) return;
    const { vin } = item;
    const { vin: curVin } = baseInfo.selectedVehicle;
    if (curVin === vin) {
      console.log("vin 相同~");
      setShowCarList(false);
      return;
    }
    setSelectedVehicle(item);
    resetVinRelativeData();
    setShowCarList(false);
    handleCurrentVeichle(item);
    sendReport({
      mcode: "切换车牌点击",
      point: "P11183`B001"
    });
  };

  const routeToReserveRecords = () => {
    const url = `/serviceOrders/mainOrderList?ch=${ch}`;
    console.log("routing url issss, ", url);
    history.push(url);
    sendReport({
      mcode: "维保记录点击",
      point: "P11183`B002"
    });
  };

  return (
    <div className={styles.vehicleWrapper}>
      <div className={styles.mainInfo}>
        <div className={styles.leftSide}>
          <div className={styles.plateNumInfo}>
            {baseInfo.selectedVehicle?.label && (
              <div className={styles.plateNum}>
                {baseInfo.selectedVehicle.label}
              </div>
            )}
            {vehicleList && vehicleList.length > 1 && (
              <div className={styles.switchCarField} onClick={onTapSwitchCar}>
                {!baseInfo.isEditingMode && <i className={styles.switchIcon} />}
                {showCarList && (
                  <div className={styles.carListField}>
                    <div className={styles.carList}>
                      {vehicleList.map((vehicleItem) => {
                        return (
                          <div
                            key={vehicleItem.vin}
                            className={classNames(styles.carListItem, {
                              // [styles.selected]: vehicleItem.label === baseInfo.selectedVehicle?.label,
                              [styles.selected]:
                                vehicleItem.vin ===
                                baseInfo.selectedVehicle?.vin
                            })}
                            onClick={(e) => {
                              e.stopPropagation();
                              onTapCarItemHandler(vehicleItem);
                            }}
                          >
                            {vehicleItem.label}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {baseInfo.selectedVehicle?.vehicleSeriesNameCn && (
            <div className={styles.subInfo}>
              {baseInfo.selectedVehicle.vehicleSeriesNameCn}
            </div>
          )}
        </div>
        {!baseInfo.isEditingMode && (
          <div className={styles.rightSide} onClick={routeToReserveRecords}>
            <span>服务记录</span>
            <i className={styles.arrowIcon} />
          </div>
        )}
      </div>
      {
        // 遮罩
        showCarList &&
          ReactDOM.createPortal(
            <div
              className={styles.carListMask}
              onClick={() => setShowCarList(false)}
            />,
            document.body
          )
      }
    </div>
  );
}
